// Pulls a lat/lng pair out of a pasted Google Maps URL, when the URL itself
// carries one. Short share links (maps.app.goo.gl/...) don't encode
// coordinates in the URL at all — resolving those would need a server-side
// redirect follow, out of scope here — so this only handles full URLs.
export function extractLatLngFromMapLink(url: string): { lat: number; lng: number } | null {
  if (!url) return null;

  // Place URLs carry the precise point as !3d<lat>!4d<lng> in the `data=`
  // param — more accurate than the map's pan/zoom center below when both
  // are present, so this is checked first.
  const dataMatch = url.match(/!3d(-?\d+\.?\d*)!4d(-?\d+\.?\d*)/);
  if (dataMatch) return { lat: Number(dataMatch[1]), lng: Number(dataMatch[2]) };

  // The map's own center after navigating to a place, e.g. .../@23.7808,90.4142,17z/...
  const atMatch = url.match(/@(-?\d+\.?\d*),(-?\d+\.?\d*)/);
  if (atMatch) return { lat: Number(atMatch[1]), lng: Number(atMatch[2]) };

  // Search/directions URLs built with an explicit coordinate query param.
  const queryMatch = url.match(/[?&](?:q|query|destination)=(-?\d+\.?\d*),(-?\d+\.?\d*)/);
  if (queryMatch) return { lat: Number(queryMatch[1]), lng: Number(queryMatch[2]) };

  return null;
}
